<template>
    <modal
      name="illion-bankstatements-modal"
      :pivotY="0.2"
      height="auto"
      :width="'95%'"
      @before-open="beforeOpen"
      :height="'auto'"
      :scrollable="true">

        <div class="border-b p-4 flex justify-between items-center">
          <div class="text-base text-gray-800">
            Bankstatements
          </div>

          <a href="#"
             @click.prevent="$modal.hide('illion-bankstatements-modal')"
             class="text-grey hover:text-grey-darker">
            <svg width="18" height="18" stroke-width="2" class="inline" stroke="currentColor" fill="none">
              <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
            </svg>
          </a>
        </div>

        <div class="p-4">
          <div class="text-sm">
            <template v-if="url == null">
              <span class="text-base text-grey-400"> Unable to upload bank statements. Please contact your broker.</span>
            </template>
            <template v-else>
              <iframe :src="url"  style='width: 100%; height: 600px;'></iframe>
            </template>
          </div>

          <div class="mt-3"></div>
        </div>

    </modal>
</template>

<script>

    export default {

        data() {
          return {
            broker: null,
            url   : null
          }
        },

        methods : {
          beforeOpen(event) {
              this.broker = event.params.broker

              if(this.broker.bankstatements_code) {
                if(this.broker.bankstatements_is_multi_bank) {
                  // note bankstatements_code needs to be the referral code which illion provides for mutli bank
                  // `-A` is added at the end in order to make the multi bank works. without it, it wont work as said by Tom.
                  this.url = 'https://scv.bankstatements.com.au/iframe/' + this.broker.bankstatements_code + '-A';
                  
                } else {
                  if (this.getEnv == 'production') {
                    this.url = 'https://www.bankstatements.com.au/iframe/start/' + this.broker.bankstatements_code
                  } else {
                    this.url = 'https://test.bankstatements.com.au/iframe/start/' + this.broker.bankstatements_code
                    console.log(this.url);
                  }
                }

              }
          },
        }
    }

</script>

